export default {
  receivables: [],
  receivableLoadingStatus: 'not loading'
}
